
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Roundtripcabbookingmumbai() {



    const cardData =
    {
        keyword: ' Round Trip Cab Booking Mumbai',
        heading: 'Deva Cabs:  Round Trip Cab Booking Mumbai',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free round trip cab booking services in Mumbai. Whether you are planning a same-day return journey to nearby destinations like Lonavala, Pune, Nashik, or Shirdi, our well-maintained fleet and professional drivers ensure a safe and smooth travel experience both ways. Round trip bookings are ideal for family outings, business meetings, and temple visits, offering convenience, cost savings, and flexibility. With transparent pricing, door-to-door pickup and drop, and multiple vehicle options, Deva Cabs guarantees a stress-free round trip travel experience from Mumbai.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "location": "Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage Site, CST (formerly Victoria Terminus) is a historic railway station in South Mumbai, built in 1887 in the Victorian Gothic Revival style. The station's stunning architecture, domes, turrets, pointed arches, and stained glass make it one of the most photographed buildings in India. Still functioning as a busy train terminal, CST represents the fusion of British and Indian architectural traditions and serves as a central landmark in Mumbai's bustling Fort area."
  },
    {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Located by the Arabian Sea in Colaba, this Indo-Saracenic structure stands 26 meters tall and draws millions of tourists each year. It serves as a starting point for ferry rides to Elephanta Caves and offers scenic views, especially during sunrise and sunset. Surrounded by bustling vendors, photographers, and the majestic Taj Mahal Palace Hotel, it’s a must-visit symbol of the city’s colonial past and vibrant present."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive, also known as the 'Queen’s Necklace', is a 3.6 km long C-shaped boulevard along the Arabian Sea in South Mumbai. Lined with palm trees and iconic Art Deco buildings (a UNESCO heritage stretch), it offers an idyllic promenade for evening walks and ocean breezes. At night, the streetlights create a necklace-like illusion across the bay. Locals and tourists come here to relax, jog, enjoy local snacks at Chowpatty Beach, or simply take in the magnificent sunset skyline."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai, Maharashtra",
    "description": "Situated on Elephanta Island, about 11 km from the Gateway of India, the Elephanta Caves are a UNESCO World Heritage Site featuring ancient rock-cut cave temples dedicated to Lord Shiva. The main cave houses the iconic 20-foot Trimurti sculpture, representing Shiva in three forms. Dating back to the 5th to 7th centuries, these caves offer a unique glimpse into India's early rock architecture. Visitors reach the island via ferry and can enjoy scenic views, local souvenirs, and a toy train ride upon arrival."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is one of the most famous and accessible beaches in Mumbai, stretching along the Arabian Sea in the upscale Juhu suburb. It's a popular spot for watching sunsets, street food (try bhelpuri and pav bhaji), and celebrity sightings. On weekends and during festivals like Ganesh Chaturthi, the beach becomes a vibrant social hub with locals, tourists, kids, and vendors creating a lively atmosphere. Its proximity to film studios and luxury hotels also makes it a favorite among Bollywood stars."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Sanjay Gandhi National Park is a 100-square-kilometer green oasis within Mumbai, offering a mix of nature, history, and adventure. Home to leopards, deer, and over 250 species of birds, the park also houses the 2,000-year-old Kanheri Caves, which are Buddhist rock-cut monuments carved into basalt rock. Visitors can enjoy jungle safaris, cycling trails, boating, toy train rides, and trekking paths—making it an ideal retreat for families and nature lovers right within city limits."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Mumbai, Maharashtra",
    "description": "Haji Ali Dargah is a revered Islamic shrine located on an islet off the coast of Worli in South Mumbai. Built in 1431, it houses the tomb of the saint Pir Haji Ali Shah Bukhari. The white marble structure is accessible via a narrow walkway surrounded by water, especially mesmerizing during high tide. It's a spiritual destination visited by people of all faiths, offering stunning views of the sea and the city’s skyline."
  },
  {
    "title": "Chor Bazaar",
    "location": "Mumbai, Maharashtra",
    "description": "Chor Bazaar, meaning 'Thieves' Market', is one of the oldest and most fascinating flea markets in Mumbai. Located near Grant Road, it’s a treasure trove for antique collectors and bargain hunters. You'll find vintage Bollywood posters, colonial furniture, old gramophones, brassware, and more. Though it was once associated with stolen goods, today it’s more about quirky curios and Mumbai’s vintage charm."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "location": "Mumbai, Maharashtra",
    "description": "Officially named Rajiv Gandhi Sea Link, this 5.6 km long cable-stayed bridge connects the suburbs of Bandra to Worli, reducing travel time dramatically. The bridge stands as a symbol of modern Mumbai, offering scenic views of the city’s skyline and the Arabian Sea. It’s especially stunning at night when illuminated. While stopping is prohibited on the bridge, the view from Bandra Fort or Worli Sea Face is a favorite for photographers and couples."
  },
  {
    "title": "Global Vipassana Pagoda",
    "location": "Gorai, Mumbai, Maharashtra",
    "description": "The Global Vipassana Pagoda is a massive meditation hall built as a tribute to the teachings of Lord Buddha. Its dome, one of the world’s largest stone structures without supporting pillars, can seat over 8,000 people. Located near Gorai Creek, the pagoda complex includes a museum, library, and guided Anapana meditation sessions. Its golden structure and peaceful surroundings attract spiritual seekers and curious tourists alike."
  }
],



  "services": [
    {
      "name": "Round Trip Cab Booking Mumbai",
      "description": "Deva Cabs makes round trip cab booking in Mumbai simple, affordable, and convenient. Whether you’re planning a business meeting in another city or a weekend getaway with family, our round trip service ensures a hassle-free return journey. Enjoy clean, well-maintained cabs, professional drivers, and transparent pricing. We offer flexible pickup and drop timings, ideal for same-day returns or overnight trips. From short distances to long drives, book your round trip cab in Mumbai with confidence and comfort."
    },
    {
      "name": "Book Round Trip Taxi Mumbai",
      "description": "Booking a round trip taxi in Mumbai is seamless with Deva Cabs. Just select your destination, preferred cab, and schedule, and we’ll take care of the rest. Whether you're heading to Pune, Lonavala, Nashik, or any other nearby city, our round trip service offers convenience, reliability, and savings. Our drivers wait for your return and ensure punctual, safe rides both ways. You no longer need to worry about finding a ride back — it’s all taken care of in one booking."
    },
    {
      "name": "Mumbai Round Trip Cab Service",
      "description": "Our Mumbai round trip cab service is designed for travelers who value time, safety, and convenience. We provide door-to-door service to nearby cities and towns, making it perfect for day trips, outstation work, or personal visits. Choose from a wide range of vehicles including sedans, SUVs, and premium cars to match your comfort and group size. With our experienced chauffeurs, round trip journeys become a smooth and pleasant experience."
    },
    {
      "name": "Affordable Round Trip Cab Hire Mumbai",
      "description": "Looking for budget-friendly round trip travel from Mumbai? Deva Cabs offers affordable round trip cab hire without compromising on comfort or service quality. Our transparent pricing, no hidden charges, and clean, AC-equipped cars make every journey economical and efficient. Whether it’s for work or a quick getaway, our round trip packages ensure you save more compared to two separate bookings — all while traveling in style."
    },
    {
      "name": "Outstation Round Trip Cab Mumbai",
      "description": "Planning an outstation journey? Our round trip cab services from Mumbai to cities like Shirdi, Mahabaleshwar, Surat, Aurangabad, and more provide complete travel flexibility. You get the same cab and driver for both onward and return trips, so there's no waiting, no delays, and no switching vehicles. Our drivers are familiar with intercity routes and ensure timely, comfortable travel throughout your trip."
    },
    {
      "name": "Chauffeur Round Trip Cab Mumbai",
      "description": "Experience the luxury of having a dedicated chauffeur with our round trip cab service in Mumbai. Our professional drivers are courteous, punctual, and knowledgeable about all major routes. Whether it’s a family vacation or a business trip, you can relax while your chauffeur ensures a smooth journey. All our cabs are fitted with AC and offer plush seating to make your round trip pleasant and stress-free."
    },
    {
      "name": "Online Round Trip Booking Mumbai",
      "description": "Skip the queues and book your round trip cab online with Deva Cabs. Our user-friendly booking platform lets you select pickup and return dates, vehicle type, and even add special instructions with ease. Get instant confirmation, fare estimates, and flexible rescheduling options — all from your mobile or desktop. Travel smarter with our reliable and easy online round trip cab booking system in Mumbai."
    },
    {
      "name": "SUV Round Trip Cab Mumbai",
      "description": "Travel with extra space and power in our SUV round trip cabs from Mumbai. Ideal for families and groups heading to outstation destinations, our SUVs provide extra luggage space, spacious interiors, and high ground clearance for comfortable long drives. Book an SUV for your round trip to ensure everyone travels together, comfortably and safely."
    },
    {
      "name": "AC Round Trip Taxi Mumbai",
      "description": "Beat the heat on your round trip with our fully air-conditioned taxis in Mumbai. Whether you’re heading to hill stations or coastal towns, our AC round trip taxis ensure cool, clean, and comfortable travel. Our drivers maintain proper hygiene and the vehicles are sanitized regularly. Book an AC cab for your next round trip journey and travel in total comfort."
    },
    {
      "name": "Premium Cab for Round Trip Mumbai",
      "description": "Upgrade your travel experience with Deva Cabs’ premium round trip cab service in Mumbai. Designed for business executives and those who enjoy finer travel, our premium cabs offer plush interiors, well-dressed chauffeurs, and on-time service. Whether it’s a business meeting or a special event, our premium round trip cabs make a lasting impression."
    },
    {
      "name": "Luxury Round Trip Car Hire Mumbai",
      "description": "Indulge in a high-end travel experience with our luxury round trip car hire services from Mumbai. Choose from a fleet of luxury sedans and SUVs driven by uniformed chauffeurs. Whether it's a wedding, corporate event, or special occasion, our luxury cars provide unmatched style and elegance for your round trip journey."
    },
    {
      "name": "Family Round Trip Cab Mumbai",
      "description": "Traveling with loved ones? Deva Cabs offers family-friendly round trip cabs in Mumbai with comfortable seating, extra luggage space, and courteous drivers. Whether it’s a pilgrimage, picnic, or family function out of town, our round trip cab service ensures a safe, reliable, and enjoyable ride for the whole family. Book early and get access to special family travel packages."
    }
  ],
  "tableData": [
    ["Round Trip Cab Booking Mumbai", "-Book Round Trip Taxi Mumbai"],
    ["Mumbai Round Trip Cab Service", "-Affordable Round Trip Cab Hire Mumbai"],
    ["Outstation Round Trip Cab Mumbai", "-Chauffeur Round Trip Cab Mumbai"],
    ["Online Round Trip Booking Mumbai", "-SUV Round Trip Cab Mumbai"],
    ["AC Round Trip Taxi Mumbai", "-Premium Cab for Round Trip Mumbai"],
    ["Luxury Round Trip Car Hire Mumbai", "-Family Round Trip Cab Mumbai"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Convenient and Flexible Round Trip Cab Service",
    "WhyChoosedescription": "Deva Cabs makes round trip travel easy and stress-free. Whether you’re heading out for a one-day business visit, a weekend getaway, or a family function in another city, our round trip cab booking gives you the freedom to travel at your own pace and return comfortably on the same day or later."
  },
  {
    "WhyChooseheading": "Affordable Round Trip Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our round trip cab fares are competitively priced and completely transparent. You pay only for what you use—no unnecessary waiting charges, hidden costs, or surprise fees. Get detailed fare estimates upfront and enjoy a cost-effective solution for your return travel needs."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for All Trip Types",
    "WhyChoosedescription": "Choose from a wide range of vehicles including sedans, SUVs, and premium cars for your round trip bookings. All vehicles are clean, air-conditioned, and equipped with comfortable seating, ample luggage space, and smooth suspension—perfect for long-distance journeys."
  },
  {
    "WhyChooseheading": "Experienced and Polite Drivers",
    "WhyChoosedescription": "Our professional drivers are courteous, well-trained, and familiar with intercity routes across Maharashtra and beyond. They ensure safe and efficient round trips from Mumbai to destinations like Pune, Lonavala, Nashik, Mahabaleshwar, Shirdi, and more—allowing you to relax and enjoy the ride."
  },
  {
    "WhyChooseheading": "Customizable Travel Schedules",
    "WhyChoosedescription": "With Deva Cabs, your round trip cab can be customized to match your exact itinerary. Make multiple stops, schedule a flexible return time, or even extend your return date—our services adapt to your plan, not the other way around. Perfect for both planned and spontaneous trips."
  },
  {
    "WhyChooseheading": "24/7 Availability for Round Trips",
    "WhyChoosedescription": "Planning a late-night return or an early morning departure? Deva Cabs offers 24/7 round trip taxi service from Mumbai, so your travel plans are never restricted by time. Our cabs operate day and night, including weekends and holidays."
  },
  {
    "WhyChooseheading": "Instant Booking and Real-Time Updates",
    "WhyChoosedescription": "Book your round trip cab easily via our app, website, or customer helpline. Receive instant confirmations, driver details, and live tracking. Our smart dispatch system ensures your return trip is well-coordinated, smooth, and perfectly timed."
  },
  {
    "WhyChooseheading": "Round Trip Packages for Personal and Business Travel",
    "WhyChoosedescription": "Whether you're a solo traveler, a family group, or a corporate client, we offer tailored round trip packages for all travel types. Enjoy full-day rentals, return-on-demand, or multi-city round trip bookings—customized to your budget and schedule."
  }
]













    }




const faqData = [
  {
    question: "Does Deva Cabs offer round trip cab booking services in Mumbai?",
    answer: "Yes, Deva Cabs provides convenient and affordable round trip cab booking services from Mumbai to various destinations. You can book easily through our website, mobile app, or customer support."
  },
  {
    question: "Which destinations are covered under round trip cab bookings from Mumbai?",
    answer: "We offer round trip services to several popular destinations from Mumbai, including Pune, Lonavala, Nashik, Mahabaleshwar, Shirdi, and more."
  },
  {
    question: "How is the fare calculated for round trip cab bookings in Mumbai?",
    answer: "Round trip fares are calculated based on total distance, vehicle type, duration of stay, and applicable tolls or parking charges. Get an instant quote through our booking platform."
  },
  {
    question: "Can I customize my return time for a round trip cab?",
    answer: "Yes, you can customize your return time while booking your round trip cab. We offer flexible scheduling to suit your travel plans."
  },
  {
    question: "What vehicle types are available for round trip bookings in Mumbai?",
    answer: "You can choose from a wide range of vehicles including hatchbacks, sedans, SUVs, and premium cars based on your comfort and group size."
  },
  {
    question: "Is it safe to travel on a round trip with Deva Cabs?",
    answer: "Absolutely! All Deva Cabs are GPS-enabled, well-maintained, and driven by experienced and verified drivers to ensure a safe journey."
  },
  {
    question: "Can I pre-schedule a round trip cab from Mumbai?",
    answer: "Yes, you can pre-schedule your round trip cab by selecting your preferred date, time, and destination through our app or website."
  },
  {
    question: "What are the payment options for round trip cab bookings?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments via our mobile app or website for hassle-free transactions."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Harshad Mehta',
    role: 'Frequent Outstation Traveler',
    review: 'I booked a round trip from Mumbai to Shirdi with Deva Cabs. The entire experience was smooth and professional. The car was clean and the driver very courteous.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    role: 'Weekend Traveler',
    review: 'Used Deva Cabs for a round trip to Lonavala. The booking was easy, and the return timing flexibility was a big plus. Will definitely use the service again!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab Booking Mumbai",
  "image": "https://devacab.com/assets/images/round-trip-cab-booking-mumbai.jpg", // Replace with actual image URL
  "description": "Book round trip cab service in Mumbai with Deva Cabs. Affordable and reliable chauffeur-driven taxis for outstation and local travel. Choose from AC sedans, SUVs, premium, and luxury cabs. Perfect for family, business, and tours.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499", // Example price, adjust based on actual fare
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/round-trip-cab-booking-mumbai" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Round Trip Cab Booking Mumbai | Outstation & Local Round Trip Taxi | Deva Cabs</title>
  <meta
    name="description"
    content="Book affordable round trip cab in Mumbai with Deva Cabs. AC sedans, SUVs, and luxury cars for outstation & local return journeys. Ideal for family, tours, and corporate trips. Chauffeur-driven comfort with online booking."
  />
  <meta
    name="keywords"
    content="Round Trip Cab Booking Mumbai, Book round trip taxi Mumbai, Mumbai round trip cab service, Affordable round trip cab hire Mumbai, Outstation round trip cab Mumbai, Chauffeur round trip cab Mumbai, Online round trip booking Mumbai, SUV round trip cab Mumbai, AC round trip taxi Mumbai, Premium cab for round trip Mumbai, Luxury round trip car hire Mumbai, Family round trip cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Roundtripcabbookingmumbai;